import React from 'react';

export function TableRowLoading() {
  return(
    <tr>
      <td className="table-loading-inside" colSpan="100%">Loading data . . .</td>
    </tr>
  )
}

export function TableRowEmpty() {
  return(
    <tr>
      <td className="table-not-found" colSpan="100%">
        <span className="icon-drawer"></span>&nbsp;data empty
      </td>
    </tr>
  )
}


// WEBPACK FOOTER //
// ./src/App/component/ComponentHelper.js